export const REDIRECT_NAME = 'Redirect'

export const PAGE_NOT_FOUND_NAME = 'PageNotFound'
export enum PageEnum {
  // login path
  BASE_LOGIN = '/login',
  // home path
  BASE_HOME = 'Home',
  // error page path
  ERROR_PAGE = '/exception',
  FIXED_PAGE = 'Overview',
}

export const BASIC_LOGIN_PATH = PageEnum.BASE_LOGIN
export const BASIC_HOME_PATH = PageEnum.BASE_HOME
export const BASIC_ERROR_PATH = PageEnum.ERROR_PAGE
